import React from 'react';
import { Button as AntButton } from 'antd';

export function Button({ children, variant = 'default', size = 'default', className = '', ...props }) {
    const getAntButtonType = () => {
        switch (variant) {
            case 'ghost':
                return 'text';
            case 'outline':
                return 'default';
            default:
                return 'primary';
        }
    };

    return (
        <AntButton
            type={getAntButtonType()}
            size={size}
            className={className}
            {...props}
        >
            {children}
        </AntButton>
    );
} 